import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NzModalRef, NzModalService} from "ng-zorro-antd/modal";
import {ItineraryService} from "../../../../core/services/itinerary.service";
import {ItineraryTemplatesService} from "../../../../core/services/itinerary-templates.service";
import {GooglePlacesService} from "../../../../core/services/google-places.service";
import {AppUtils} from "../../../../core/config/app.utils";
import {SETTINGS} from "../../../../core/config/common.settings";
import * as moment from "moment";
import {NzMessageService} from "ng-zorro-antd/message";
import {NzUploadChangeParam, NzUploadFile, NzUploadXHRArgs} from "ng-zorro-antd/upload";
import {UploadService} from "../../../../core/services/upload.service";
import { LanguageService } from '../../../../core/services/language.service';
import { OpenAiService } from '../../../../core/services/open-ai.service';
import { RoomCategoriesService } from '../../../../core/services/room-categories.service';
import { RoomTypesService } from '../../../../core/services/room-types.service';
import { MealPlansService } from '../../../../core/services/meal-plans.service';
import { ContractsService } from '../../../../core/services/contracts.service';
import { SettingService } from '../../../../core/services/setting.service';
import { AuthService } from '../../../../modules/auth/services/auth.service';
import { TranslocoService } from '@ngneat/transloco';
import { withItineraryLockSession } from '../../../../core/ult-functions/itinerary-tab-session';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { amountParser, currencyFormatter } from "../../../../core/ult-functions/currency-calculation";
import { Router } from '@angular/router';
import { FileService } from 'src/app/core/services/file.service';

@Component({
  selector: "app-add-edit-accommodation-content",
  templateUrl: "./add-edit-accommodation-content.component.html",
  styleUrls: ["./add-edit-accommodation-content.component.scss"]
})
export class AddEditAccommodationContentComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() itinerary?: any;
  @Input() mode?: any;
  @Input() accommodationId?: any;
  @Input() country?: string;
  @Input() vatPercentage?: number;
  @Input() itineraryMode: 'itinerary' | 'template' = 'itinerary';
  @Input() sessionId?: string;

  searchName = "";
  accommodationForm: any;
  formErrors: any;
  googlePlaceDetails: any | undefined;
  tempSuggestion: any;
  isHotelSelected = false;
  listOfOption: any = [];
  selectedAccommodate?: string;
  imageURLS: any = [];
  imageUri?: string;
  accommodationIndex = -1;
  fileList: NzUploadFile[] = [];
  loading = false;
  tempAccommodationName = "";
  listOfRoomCatoOptions: any = [];
  listOfMealTypeOptions: any = [];
  listOfRoomTypeOptions: any = [];
  languages: any[] = [];
  currentCountryBoxChecked = false;
  countyData: any;
  currencies: any[] = [];
  isPrimaryCurrency = true;
  isButtonLoading = false;
  dateCheckOutOptions: any[] = [];
  dateCheckInOptions: any[] = [];
  hotelContracts: any[] = [];
  onEditPlaceID = '';
  toggleRoomBreakdown = false;
  toggleNotes = false;
  private destroy$ = new Subject<void>();

  protected readonly SETTINGS = SETTINGS;
  @ViewChild("searchBar",  {static: false, read: ElementRef }) searchBar!: ElementRef;

  get activeService(): ItineraryService | ItineraryTemplatesService {
    return this.itineraryMode === 'template' ? this.itineraryTemplatesService : this.itineraryService;
  }

  constructor(private fb: FormBuilder,
              private modal: NzModalRef,
              private message: NzMessageService,
               private itineraryService: ItineraryService,
               private itineraryTemplatesService: ItineraryTemplatesService,
               private googlePlacesService: GooglePlacesService,
              private uploadService: UploadService,
              private modalConfirm: NzModalService,
              private languageService: LanguageService,
              private openAiService: OpenAiService,
              private roomCategoriesService: RoomCategoriesService,
              private roomTypesService: RoomTypesService,
              private mealPlansService: MealPlansService,
              private contractsService: ContractsService,
              private settingService: SettingService,
              private authService: AuthService,
              private router: Router,
              private fileService: FileService,
              private translocoService: TranslocoService,) {
    this.formErrors = {
      checkIn: {},
      checkOut: {},
      mealType: {},
      roomType: {},
      roomCategory: {},
      noOfRooms: {},
      perChildSupplement: {},
      perInfantFee: {},
      roomRate: {},
      notes: {},
      rating: {},
    };
  }

  ngOnInit(): void {
    this.getLanguages();
    this.addCurrency();

    // Initialise option lists with language-filtered defaults so dropdowns are never empty
    this.listOfRoomTypeOptions = this.getFallbackOptions(SETTINGS.ROOM_TYPES);
    this.listOfMealTypeOptions = this.getFallbackOptions(SETTINGS.MEAL_PLANS);
    this.listOfRoomCatoOptions = this.getFallbackOptions(SETTINGS.ROOM_CATEGORIES);

    this.accommodationForm = this.fb.group({
      checkIn: ["", [Validators.required]],
      checkOut: [{value: "", disabled: true}, [Validators.required]],
      websiteUri: ["", [Validators.pattern(SETTINGS.REGEX.URL.EXP)]],
      hotelDescription: [""],
      rooms: this.fb.array([]),
      perChildSupplement: [0],
      perInfantFee: [0],
      notes: [""],
      rating : [""],
      isTaxed: [false],
      extraCost: this.fb.array([]),
    });
    if (this.itinerary.tour.isDatesOptional) {
      this.generateCheckInOptions();
      this.generateCheckOutOptions();
    }

    this.accommodationForm.get("checkIn")?.valueChanges.subscribe(() => {
      this.fetchContracts();
    });

    this.accommodationForm.get("checkOut")?.valueChanges.subscribe(() => {
      this.fetchContracts();
    });

    if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.NEW) {
      if (this.itinerary.accommodation.length !== 0){
        this.itinerary.accommodation[0].rooms.forEach(({ mealType, roomCategory, roomType, noOfRooms, roomRate, cost }: any) => {

          // If not exists roomCategory, add the new object
          // if (!this.customTypeExists(this.listOfRoomCatoOptions, roomCategory)) {
          //   this.listOfRoomCatoOptions.push({ value: roomCategory, label: roomCategory });
          // }

          // if (!this.customTypeExists(this.listOfMealTypeOptions, mealType)) {
          //   this.listOfMealTypeOptions.push({ value: mealType, label: mealType });
          // }

          // if (!this.customTypeExists(this.listOfRoomTypeOptions, roomType)) {
          //   this.listOfRoomTypeOptions.push({ value: roomType, label: roomType });
          // }

          this.addRoom(mealType, roomCategory, roomType, noOfRooms, 0, 0);
        });
      }
    }

    if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
      this.accommodationIndex = this.itinerary.accommodation.findIndex((accommodation: any) => accommodation._id === this.accommodationId);
      this.isPrimaryCurrency = this.itinerary.accommodation[this.accommodationIndex]?.isPrimaryCurrency ?? true;
      this.accommodationForm.patchValue(
        this.itinerary.accommodation[this.accommodationIndex],
        {emitEvent: false}
      );
      this.onEditPlaceID = this.itinerary.accommodation[this.accommodationIndex]?.googleID || '';
      this.fetchContracts();
      const accRooms = this.itinerary.accommodation[this.accommodationIndex].rooms;
      const roomCategories = Array.from(new Set<string>(accRooms.map((r: any) => r.roomCategory as string)));
      const roomTypes = Array.from(new Set<string>(accRooms.map((r: any) => r.roomType as string)));
      const mealTypes = Array.from(new Set<string>(accRooms.map((r: any) => r.mealType as string)));

      this.getMealPlan(mealTypes);
      this.getRoomCategory(roomCategories);
      this.getRoomType(roomTypes);
      const accExtraCosts = this.itinerary.accommodation[this.accommodationIndex]?.extraCost ?? [];
      accExtraCosts.forEach(({ name, cost }: { name: string; cost: number }) => {
        this.addExtraCost(name, cost);
      });

      accRooms.forEach(({ mealType, roomCategory, roomType, noOfRooms, roomRate, cost }: any) => {
        this.addRoom(mealType, roomCategory, roomType, noOfRooms, roomRate, cost);
      });
      this.isHotelSelected = true;
      this.imageUri = this.itinerary.accommodation[this.accommodationIndex].photoUri;
      this.imageURLS = this.itinerary.accommodation[this.accommodationIndex].allPhotos;
      this.tempAccommodationName = this.itinerary.accommodation[this.accommodationIndex].name;

      this.accommodationForm.get("checkOut").enable();

    }


    this.accommodationForm.get("checkIn").valueChanges.subscribe((checkInValue: string) => {
      if (checkInValue !== undefined && checkInValue !== "" && this.mode !== SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
        this.accommodationForm.get("checkOut").enable();
        if (this.itinerary.tour.isDatesOptional) {
          this.generateCheckOutOptions();
        }
      }
    });

    this.accommodationForm.get("checkOut").valueChanges.subscribe((checkOutValue: string) => {
      if (checkOutValue !== undefined && checkOutValue !== "") {
        const existingHotelIndex: string[] = [];
        const selectedCheckOut = moment(checkOutValue);
        const selectedCheckIn = moment(this.accommodationForm.get("checkIn").value);
        this.itinerary.accommodation.filter((accommodation: any) => accommodation._id !== this.accommodationId).forEach((accommodation: any, index: number) => {
          const checkinDate = moment(accommodation.checkIn);
          const checkoutDate = moment(accommodation.checkOut);
          if (
            !(selectedCheckOut.isSame(checkinDate) || selectedCheckIn.isSame(checkoutDate)) && // Allow adjacent bookings
            (
              selectedCheckIn.isBetween(checkinDate, checkoutDate, null, '[)') ||
              selectedCheckOut.isBetween(checkinDate, checkoutDate, null, '(]') ||
              (selectedCheckIn.isSameOrBefore(checkinDate) && selectedCheckOut.isSameOrAfter(checkoutDate)) // Fully overlaps an existing range
            )
          ){
            console.log("The check-in and check-out period includes the given date.");
            existingHotelIndex.push(accommodation._id);
          } else {
            console.log("The check-in and check-out period does not include the given date.");
          }
        });

        if (existingHotelIndex.length !== 0) {
          this.showBookingConfirm(existingHotelIndex);
        }
      }
    });

    this.accommodationForm.valueChanges.subscribe((form: any) => {
      this.formErrors = AppUtils.getFormErrors(this.accommodationForm, this.formErrors);
    });

    this.uploadService.onUploadedFileChange.subscribe(value => {
      this.loading = false;
    });

    this.accommodationForm.get("rooms").valueChanges.subscribe((rooms: any[]) => {
      rooms.forEach((room, index) => {
        const roomGroup = this.getRooms().at(index);

        // Listen to noOfRooms and roomRate changes
        roomGroup.get("noOfRooms")?.valueChanges.subscribe((newNoOfRooms) => {
          const roomRate = roomGroup.get("roomRate")?.value || 0;
          roomGroup.get("cost")?.setValue(this.calcRoomCost(newNoOfRooms, roomRate), {emitEvent: false});
        });

        roomGroup.get("roomRate")?.valueChanges.subscribe((newRoomRate) => {
          const noOfRooms = roomGroup.get("noOfRooms")?.value || 0;
          roomGroup.get("cost")?.setValue(this.calcRoomCost(noOfRooms, newRoomRate), {emitEvent: false});
        });
      });
    });

    this.accommodationForm.get("isTaxed")?.valueChanges.subscribe(() => {
      this.recalculateRoomCosts();
    });

    this.accommodationForm.get("rooms").updateValueAndValidity({ emitEvent: true });

    this.translocoService.langChanges$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.filterFallbackOptionsByLang();
      });
  }

  ngAfterViewInit(): void {
    if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
      this.setSearchText(this.tempAccommodationName); // Example text to be set after view initializes
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private getFallbackOptions(
    options: Array<{ value: string; label: string; language: string }>
  ): Array<{ value: string; label: string }> {
    const lang = this.translocoService.getActiveLang();
    const filtered = options.filter(item => item.language === lang);
    return (filtered.length ? filtered : options.filter(item => item.language === 'en'))
      .map(({ value, label }) => ({ value, label }));
  }

  private filterFallbackOptionsByLang(): void {
    if (this.listOfRoomTypeOptions.length > 0 && !this.listOfRoomTypeOptions[0]._id) {
      this.listOfRoomTypeOptions = this.getFallbackOptions(SETTINGS.ROOM_TYPES);
    }
    if (this.listOfMealTypeOptions.length > 0 && !this.listOfMealTypeOptions[0]._id) {
      this.listOfMealTypeOptions = this.getFallbackOptions(SETTINGS.MEAL_PLANS);
    }
    if (this.listOfRoomCatoOptions.length > 0 && !this.listOfRoomCatoOptions[0]._id) {
      this.listOfRoomCatoOptions = this.getFallbackOptions(SETTINGS.ROOM_CATEGORIES);
    }
  }


  setSearchText(text: string):void {
    setTimeout(() => {
      if (!this.searchBar) {
        console.error('searchBar is undefined');
        return;
      }

      const inputElement = this.searchBar.nativeElement.querySelector("input");
      if (inputElement) {
        inputElement.value = text; // Set the value programmatically
        inputElement.dispatchEvent(new Event("input")); // Ensure Angular detects the change
      }
    }, 100);
  }

  showBookingConfirm(indexs: string[]): void {
    this.modalConfirm.confirm({
      nzTitle: this.translocoService.translate('itineraries.accommodation.bookingModal.title'),
      nzClosable: false,
      nzMaskClosable: false,
      nzContent: this.translocoService.translate('itineraries.accommodation.bookingModal.content'),
      nzOkText: this.translocoService.translate('itineraries.accommodation.bookingModal.keepCurrent'),
      nzOkType: "primary",
      nzOnOk: () => {
        this.accommodationForm.get("checkOut").reset({value: "", disabled: true});
        this.accommodationForm.get("checkIn").reset({value: "", disabled: false});
        this.accommodationForm.updateValueAndValidity();
      },
      nzCancelText: this.translocoService.translate('itineraries.accommodation.bookingModal.replaceAll'),
      nzOnCancel: () => {
        this.itinerary.accommodation = this.itinerary.accommodation.filter((acc: any) => !indexs.includes(acc._id));
      }
    });
  }

  async fetchContracts(): Promise<any> {
    const checkIn = this.accommodationForm.get("checkIn")?.value;
    const checkOut = this.accommodationForm.get("checkOut")?.value;

    if (checkIn && checkOut) {
      const payload = {
        startDate: checkIn,
        endDate: checkOut,
        currency: this.currencies.find(c => c.value === this.isPrimaryCurrency)?.label,
        googleID: this.tempSuggestion?.placeId || this.onEditPlaceID || ''
      };

      try {
        this.hotelContracts = await this.contractsService.getContractsByHotel(payload);
      } catch (e) {
        console.error(e);
      }
    }
  }

  async searchHotel(value: string): Promise<any> {
    if (value !== "") {
      const payload = this.getPayload(this.currentCountryBoxChecked, value);
      this.googlePlacesService.postAutoComplete({
        ...payload,
      }).then(res => {

        this.listOfOption = res.suggestions;
      });
    }
  }

  async selectedAccommodation(data: any): Promise<any> {
    try {
      this.tempSuggestion = data;
      this.googlePlaceDetails = await this.googlePlacesService.getPlaceDetails(data.placeId);
      this.imageURLS = await this.googlePlacesService.getPlacePhoto(this.googlePlaceDetails.photos);
      this.imageUri = this.imageURLS[0];
      this.mapImages();

      // patching values to the form
      this.accommodationForm.patchValue(
        {
          websiteUri: this.googlePlaceDetails?.websiteUri,
          hotelDescription: this.googlePlaceDetails?.editorialSummary?.text,
          rating: this.googlePlaceDetails?.rating,
        }
        , {emitEvent: false}
      );
      this.isHotelSelected = true;
      this.getMealPlan();
      this.getRoomCategory();
      this.getRoomType();
      this.fetchContracts();
    } catch (e) {
      console.log(e);
      this.message.error(this.translocoService.translate('itineraries.accommodation.messages.somethingWentWrong'));
    }
  }

  mealTypeChange(value: string, roomIndex: number): void {
    const roomsArray = this.accommodationForm.get("rooms") as FormArray;
    const roomGroup = roomsArray.at(roomIndex) as FormGroup;
    if (roomGroup) {
      roomGroup.get("mealType")?.setValue(value);
    }
  }

  handleCancel(): void {
    this.modal.close();
  }

  disabledDateCheckIn = (current: Date| string): boolean => {
    const accommodations = [...this.itinerary.accommodation];
    const start = moment(this.itinerary.tour.startDate).startOf("day");
    const end = moment(this.itinerary.tour.endDate).endOf("day");
    const currentMoment = moment(current).startOf("day");

    // mode is on edit, the specify accommodation is removed. So the dates will open up
    if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
      accommodations.splice(this.accommodationIndex, 1);
    }

    // Disable dates that are not within the range
    if (currentMoment.isBefore(start) || currentMoment.isAfter(end)) {
      return true;
    }

    // Iterate through accommodations to disable check-in and check-out dates only
    for (const accommodation of accommodations) {
      const checkIn = moment(accommodation.checkIn).startOf("day");
      let checkOut = moment(accommodation.checkOut).startOf("day");

      if (!checkOut.isSame(checkIn)) {
        checkOut = checkOut.subtract(1, "day");
      }

      if (currentMoment.isSameOrAfter(checkIn) && currentMoment.isSameOrBefore(checkOut)) {
        return true;
      }
    }
    return false;
  }

  disabledDateCheckOut = (current: Date | string): boolean => {
    const accommodations: any = [];
    const start = moment(this.accommodationForm.get("checkIn").value).startOf("day");
    const end = moment(this.itinerary.tour.endDate).endOf("day");
    const currentMoment = moment(current).startOf("day");

    // Disable dates that are not within the range
    if (currentMoment.isBefore(start) || currentMoment.isAfter(end)) {
      return true;
    }

    // Iterate through accommodations to disable check-in and check-out dates only
    for (const accommodation of accommodations) {
      const checkIn = moment(accommodation.checkIn).startOf("day");
      let checkOut = moment(accommodation.checkOut).startOf("day");

      if (!checkOut.isSame(checkIn)) {
        checkOut = checkOut.subtract(1, "day");
      }

      if (currentMoment.isSameOrAfter(checkIn) && currentMoment.isSameOrBefore(checkOut)) {
        return true;
      }
    }
    return false;
  }

  async addAccommodation(): Promise<any> {
    this.isButtonLoading = true;
    try {
      let payload = [];
      const formData = this.accommodationForm.getRawValue();
      // formData.roomRate = formData.roomRate !== "" ? formData.roomRate : 0;
      formData.perChildSupplement = formData.perChildSupplement !== "" ? formData.perChildSupplement : 0;
      formData.perInfantFee = formData.perInfantFee !== "" ? formData.perInfantFee : 0;
      await this.uploadSelectedUrlImage(this.imageUri);

      if (this.itinerary.accommodation.length !== 0) {
        const tCost = this.getTotalCost();
        payload = this.itinerary.accommodation;
        payload.push({
          totalCost: tCost,
          name: this.tempSuggestion.structuredFormat.mainText.text,
          photoUri: this.imageUri,
          allPhotos: this.imageURLS,
          ...formData,
          isPrimaryCurrency: this.isPrimaryCurrency,
          googleID: this.tempSuggestion.placeId
        });

        await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, accommodation: payload}, this.sessionId!));
        this.isButtonLoading = false;
        this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ADD_SUCCESS);
      } else {
        const tCost = this.getTotalCost();
        payload.push({
          totalCost: tCost,
          name: this.tempSuggestion.structuredFormat.mainText.text,
          photoUri: this.imageUri,
          allPhotos: this.imageURLS,
          ...formData,
          isPrimaryCurrency: this.isPrimaryCurrency,
          googleID: this.tempSuggestion.placeId
        });

        await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, accommodation: payload}, this.sessionId!));
        this.isButtonLoading = false;
        this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ADD_SUCCESS);
      }

    } catch (e) {
      this.isButtonLoading = false;
      this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ERROR);
    }
  }


  async editAccommodation(): Promise<any> {
    this.isButtonLoading = true;
    try {
      const payload = this.itinerary.accommodation;
      const formData = this.accommodationForm.getRawValue();
      // formData.roomRate = formData.roomRate !== "" ? formData.roomRate : 0;
      formData.perChildSupplement = formData.perChildSupplement !== "" ? formData.perChildSupplement : 0;
      formData.perInfantFee = formData.perInfantFee !== "" ? formData.perInfantFee : 0;
      const tCost = this.getTotalCost();
      await this.uploadSelectedUrlImage(this.imageUri);
      payload.splice(this.accommodationIndex, 1, {
        totalCost: tCost,
        name: this.tempSuggestion?.structuredFormat?.mainText?.text ? this.tempSuggestion?.structuredFormat?.mainText?.text : this.tempAccommodationName,
        photoUri: this.imageUri,
        allPhotos: this.imageURLS,
        ...formData,
        isPrimaryCurrency: this.isPrimaryCurrency,
        googleID: this.tempSuggestion?.placeId || this.onEditPlaceID || ''
      });

      await this.activeService.updateItineraryLockState(withItineraryLockSession({_id: this.itinerary._id, accommodation: payload}, this.sessionId!));
      this.isButtonLoading = false;
      this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.EDIT_SUCCESS);

    } catch (e) {
      this.isButtonLoading = false;
      this.modal.close(SETTINGS.ITINERARY_MESSAGE_STATUS.ERROR);
    }
  }

  addRoom(mealType: string, roomCategory: string, roomType: string, noOfRooms: number, roomRate: number, cost: number): void {
    this.getRooms().push(
      this.fb.group({
        mealType: [mealType, [Validators.required]],
        roomType: [roomType, [Validators.required]],
        roomCategory: [roomCategory, [Validators.required]],
        noOfRooms: [noOfRooms],
        roomRate: [roomRate],
        cost: [cost],
      })
    );
  }

  getRooms(): FormArray {
    return this.accommodationForm.get("rooms");
  }

  removeRoom(roomIndex: number): void {
    this.getRooms().removeAt(roomIndex);
  }

  getExtraCosts(): FormArray {
    return this.accommodationForm.get("extraCost") as FormArray;
  }

  addExtraCost(name: string = "", cost: number = 0, baseRate?: number): void {
    const isTaxed = this.accommodationForm.get("isTaxed")?.value ?? false;
    const vat = isTaxed ? (this.vatPercentage ?? 0) : 0;
    // If baseRate is not provided, back-calculate it from cost
    const resolvedBaseRate = baseRate !== undefined ? baseRate : (isTaxed && vat > 0 ? cost / (1 + vat / 100) : cost);
    const resolvedCost = resolvedBaseRate * (1 + vat / 100);

    const extraGroup = this.fb.group({
      name: [name],
      baseRate: [resolvedBaseRate],
      cost: [resolvedCost],
    });

    extraGroup.get("baseRate")?.valueChanges.subscribe((newBaseRate: number | null) => {
      const isTaxedNow = this.accommodationForm.get("isTaxed")?.value ?? false;
      const vatNow = isTaxedNow ? (this.vatPercentage ?? 0) : 0;
      extraGroup.get("cost")?.setValue((newBaseRate ?? 0) * (1 + vatNow / 100), { emitEvent: false });
    });

    this.getExtraCosts().push(extraGroup);
  }

  removeExtraCost(index: number): void {
    this.getExtraCosts().removeAt(index);
  }

  getRoomsLength(): number {
    const rooms = this.getRooms();
    return rooms ? rooms.length : 0;
  }

  cancel(): void {
  }

  calcRoomCost(noOfRooms: number, roomRate: number): number {
    const isTaxed = this.accommodationForm.get("isTaxed")?.value ?? false;
    const vat = isTaxed ? (this.vatPercentage ?? 0) : 0;
    return noOfRooms * roomRate * (1 + vat / 100);
  }

  recalculateRoomCosts(): void {
    this.getRooms().controls.forEach((roomGroup) => {
      const roomRate = roomGroup.get("roomRate")?.value || 0;
      const noOfRooms = roomGroup.get("noOfRooms")?.value || 0;
      roomGroup.get("cost")?.setValue(this.calcRoomCost(noOfRooms, roomRate), {emitEvent: false});
    });
    this.recalculateExtraCosts();
  }

  recalculateExtraCosts(): void {
    const isTaxed = this.accommodationForm.get("isTaxed")?.value ?? false;
    const vat = isTaxed ? (this.vatPercentage ?? 0) : 0;
    this.getExtraCosts().controls.forEach((extraGroup) => {
      const baseRate = extraGroup.get("baseRate")?.value || 0;
      extraGroup.get("cost")?.setValue(baseRate * (1 + vat / 100), { emitEvent: false });
    });
  }

  getTotalCost(): number {
    const rooms = this.accommodationForm.get("rooms").value as any[];
    let totalCost = 0;
    rooms.forEach((room: any) => {
      totalCost += room.cost ?? 0;
    });

    const extraCosts = this.getExtraCosts().value as any[];
    extraCosts.forEach((extra: any) => {
      totalCost += extra.cost ?? 0;
    });

    return totalCost;
  }

  getRoomCostBreakdown(index: number): { baseRate: number; vatAmount: number; total: number } {
    const roomGroup = this.getRooms().at(index);
    const roomRate = roomGroup.get("roomRate")?.value ?? 0;
    const noOfRooms = roomGroup.get("noOfRooms")?.value ?? 0;
    const isTaxed = this.accommodationForm.get("isTaxed")?.value ?? false;
    const vat = isTaxed ? (this.vatPercentage ?? 0) : 0;
    const baseRate = roomRate * noOfRooms;
    const vatAmount = baseRate * vat / 100;
    return { baseRate, vatAmount, total: baseRate + vatAmount };
  }

  getExtraCostBreakdown(index: number): { baseRate: number; vatAmount: number; total: number } {
    const extraGroup = this.getExtraCosts().at(index);
    const baseRate = extraGroup.get("baseRate")?.value ?? 0;
    const isTaxed = this.accommodationForm.get("isTaxed")?.value ?? false;
    const vat = isTaxed ? (this.vatPercentage ?? 0) : 0;
    const vatAmount = baseRate * vat / 100;
    return { baseRate, vatAmount, total: baseRate + vatAmount };
  }

  getSelectedImage(): any {
    if (this.imageUri) {
      return this.imageUri;
    } else {
      this.imageUri = this.imageURLS[0];
      return this.imageUri;
    }
  }

  customUploadReq = (item: NzUploadXHRArgs | any) => {
    this.loading = true;
    const formData = new FormData();
    formData.append("file", item.file);
    return this.uploadService.uploadFile(formData, item);
  }

  handleChange(event: NzUploadChangeParam): any {
    if (event && event.type === "success" && event.file.response.url) {
      this.imageURLS.push(event.file.response.url);
    }
  }

  onRemove = (item: NzUploadXHRArgs | any) => {
    this.imageURLS = this.imageURLS.filter(
      (x: any) => x !== item.url
    );
    return true;
  }

  setMediaUploadHeaders = (file: any) => {
    return {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    };
  }

  mapImages(): void {
    this.fileList = this.imageURLS.map(
      (image: any, index: number) => ({
        uid: (index + 1).toString(),
        name: "image.png",
        status: "done",
        url: image,
      }));
  }

  addCatoItem(input: HTMLInputElement): void {
    const value = input.value;
    this.listOfRoomCatoOptions = [...this.listOfRoomCatoOptions, { value, label: value }];
  }
  addRoomTypeItem(input: HTMLInputElement): void {
    const value = input.value;
    this.listOfRoomTypeOptions = [...this.listOfRoomTypeOptions, { value, label: value }];
  }
  addMealTypeItem(input: HTMLInputElement ): void {
    const value = input.value;
    this.listOfMealTypeOptions = [...this.listOfMealTypeOptions, { value, label: value }];
  }

  async getRoomType(preserveValues: string[] = []): Promise<void> {
      const placeId = this.tempSuggestion?.placeId || this.onEditPlaceID || '';
      const res = await this.roomTypesService.search(placeId);
      if (res && res.length > 0) {
        this.listOfRoomTypeOptions = res.map((item: any) => ({ value: item.name, label: item.name, _id: item._id }));
      } else {
        this.listOfRoomTypeOptions = this.getFallbackOptions(SETTINGS.ROOM_TYPES);
      }
      preserveValues.forEach(val => {
        if (val && !this.customTypeExists(this.listOfRoomTypeOptions, val)) {
          this.listOfRoomTypeOptions.push({ value: val, label: val });
        }
      });
  }

  async getRoomCategory(preserveValues: string[] = []): Promise<void> {
      const placeId = this.tempSuggestion?.placeId || this.onEditPlaceID || '';
      const res = await this.roomCategoriesService.search(placeId);
      if (res && res.length > 0) {
        this.listOfRoomCatoOptions = res.map((item: any) => ({ value: item.name, label: item.name, _id: item._id }));
      } else {
        this.listOfRoomCatoOptions = this.getFallbackOptions(SETTINGS.ROOM_CATEGORIES);
      }
      preserveValues.forEach(val => {
        if (val && !this.customTypeExists(this.listOfRoomCatoOptions, val)) {
          this.listOfRoomCatoOptions.push({ value: val, label: val });
        }
      });
  }

  async getMealPlan(preserveValues: string[] = []): Promise<void> {
      const placeId = this.tempSuggestion?.placeId || this.onEditPlaceID || '';
      const res = await this.mealPlansService.search(placeId);
      if (res && res.length > 0) {
        this.listOfMealTypeOptions = res.map((item: any) => ({ value: item.code, label: (item.name + ' (' + item.code + ')'), _id: item._id }));
      } else {
        this.listOfMealTypeOptions = this.getFallbackOptions(SETTINGS.MEAL_PLANS);
      }
      preserveValues.forEach(val => {
        if (val && !this.customTypeExists(this.listOfMealTypeOptions, val)) {
          this.listOfMealTypeOptions.push({ value: val, label: val });
        }
      });
  }

  getMatchingContracts(index: number): any[] {
    const room = this.getRooms().at(index).value;
    const mealPlan = this.listOfMealTypeOptions.find((m: any) => m.value === room.mealType);
    const roomType = this.listOfRoomTypeOptions.find((r: any) => r.value === room.roomType);
    const roomCategory = this.listOfRoomCatoOptions.find((c: any) => c.value === room.roomCategory);
    if (this.hotelContracts && mealPlan && roomType && roomCategory) {
      return this.hotelContracts.filter((c: any) =>
        c.mealPlan._id === mealPlan._id &&
        c.roomType._id === roomType._id &&
        c.roomCategory._id === roomCategory._id
      );
    }
    return [];
  }

  setRoomRate(index: number, rate: number): void {
    const roomGroup = this.getRooms().at(index);
    if (roomGroup) {
      roomGroup.get("roomRate")?.setValue(rate);
      const noOfRooms = roomGroup.get("noOfRooms")?.value || 0;
      roomGroup.get("cost")?.setValue(noOfRooms * rate, { emitEvent: false });
    }
  }

  customTypeExists(list: any, value: string ): boolean {
    return  list.some((option: any) => option.value === value);
  }

  async getLanguages(): Promise<any> {
    this.languages = await this.languageService.getContentLanguages();
  }

  async translateHotelDescription(text: any): Promise<any> {
    this.loading = true;
    const langType = this.languages?.find((l: any) => l.code === this.itinerary.tour.language);

    const payload = ` ${text}
    Translate above english into ${langType.name}.
    if the above text is not in english, rewrite text in ${langType.name} and remove any english parts `;

    try {
      const answer = await this.openAiService.askChatGPT({query: payload});
      if (answer) {
        this.accommodationForm.patchValue({hotelDescription: answer.choices[0].message.content});
      }
      this.loading = false;
    } catch (error) {
      this.message.error(this.translocoService.translate('itineraries.accommodation.messages.translateIssue'));
      this.loading = false;
    }
  }

  onChangeCurrentCountry(value: any): void {
    this.currentCountryBoxChecked = value;

    if (this.currentCountryBoxChecked) {
      this.loading = true;
      this.getCurrentLocation().then(r => {
        this.countyData = r;
        this.loading = false;
      });
    }
  }

  async getCurrentLocation(): Promise<any> {
    try {
      return await this.googlePlacesService.postTextSearch({
        text: this.country
      });
    } catch (e) {
      this.message.error(this.translocoService.translate('itineraries.accommodation.messages.countrySearchNotWorking'));
    }
  }

  getPayload(isRestrict: boolean, value: string): any {
    if (isRestrict && this.countyData) {
      return {
        input: value,
        locationRestriction: {
          rectangle: {
            high: {
              latitude: this.countyData?.viewport?.high.latitude,
              longitude: this.countyData?.viewport?.high.longitude
            },
            low: {
              latitude: this.countyData?.viewport?.low.latitude,
              longitude: this.countyData?.viewport?.low.longitude
            }
          }
        },
        primaryTypes: ["lodging", "hotel", "establishment"]
      };
    } else {
      return {
        input: value,
        primaryTypes: ["lodging", "hotel", "establishment"]
      };
    }
  }

  addCurrency(): void {
    if (this.itinerary?.tour?.currency) {
      this.currencies.push({label: this.itinerary?.tour?.currency, value: true});
    }

    if (this.itinerary?.tour?.secondaryCurrency !== ""){
      this.currencies.push({label: this.itinerary?.tour?.secondaryCurrency, value: false});
    }
  }

  private isItineraryDayBooked(dateString: string, accommodations: any[]): boolean {
    const currentMoment = moment(dateString, "YYYY-MM-DD", true).startOf("day");

    for (const accommodation of accommodations) {
      const checkIn = moment(accommodation.checkIn, "YYYY-MM-DD", true).startOf("day");
      let checkOut = moment(accommodation.checkOut, "YYYY-MM-DD", true).startOf("day");

      if (!checkOut.isSame(checkIn)) {
        checkOut = checkOut.subtract(1, "day");
      }

      if (currentMoment.isSameOrAfter(checkIn) && currentMoment.isSameOrBefore(checkOut)) {
        return true;
      }
    }

    return false;
  }

  generateCheckInOptions(): void {
    let accommodations = [...(this.itinerary?.accommodation ?? [])];

    if (this.mode === SETTINGS.ITINERARY_CONTENT_MODE.EDIT) {
      accommodations.splice(this.accommodationIndex, 1);
    }

    this.dateCheckInOptions = (this.itinerary?.days ?? []).map((day: any, index: number) => {
      const dateString = moment(day.date).format("YYYY-MM-DD");

      return {
        value: dateString,
        label: this.translocoService.translate("itineraries.accommodation.form.dayLabel", { day: index + 1 }),
        disabled: this.isItineraryDayBooked(dateString, accommodations),
      };
    });
  }

  generateCheckOutOptions(): void {
    const checkInValue = this.accommodationForm.get("checkIn")?.value;
    const checkInMoment = checkInValue
      ? moment(checkInValue, "YYYY-MM-DD", true).startOf("day")
      : null;

    this.dateCheckOutOptions = (this.itinerary?.days ?? []).map((day: any, index: number) => {
      const dateString = moment(day.date).format("YYYY-MM-DD");
      const currentMoment = moment(dateString, "YYYY-MM-DD", true).startOf("day");
      const disabled = checkInMoment ? currentMoment.isBefore(checkInMoment) : false;

      return {
        value: dateString,
        label: this.translocoService.translate("itineraries.accommodation.form.dayLabel", { day: index + 1 }),
        disabled,
      };
    });
  }

  uploadSelectedUrlImage(imageUrl: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        if (!imageUrl) {
          const noImageUrlMessage = this.translocoService.translate('itineraries.accommodation.messages.noImageUrlProvided');
          this.message.error(noImageUrlMessage);
          reject(noImageUrlMessage);
          return;
        }

        // Check if the URL is already an S3 URL
        if (this.isS3Url(imageUrl)) {
          // If it's already an S3 URL, just add it to the imageURLS array
          this.imageUri = imageUrl;
          this.message.success(this.translocoService.translate('itineraries.accommodation.messages.imageUrlAddedSuccessfully'));
          resolve();
          return;
        }

        this.loading = true;

        // Download the image from the URL
        const response = await fetch(imageUrl);
        if (!response.ok) {
          throw new Error(`Failed to download image: ${response.statusText}`);
        }

        // Convert the response to blob
        const blob = await response.blob();

        // Create a File object from the blob
        const fileName = `image_${Date.now()}.jpg`;
        const file = new File([blob], fileName, { type: blob.type });
        const formData = new FormData();
        formData.append('file', file);
        const uploadItem = {
          file,
          onProgress: (event: any, file: any) => {
            // Handle progress if needed
          },
          onSuccess: (response: any, file: any, event: any) => {
            this.loading = false;
            // Add the new uploaded URL to the imageURLS array
            if (response && response.url) {
              this.imageUri = response.url;
              this.message.success(this.translocoService.translate('itineraries.accommodation.messages.imageUploadedSuccessfully'));
              resolve(response);
            }
          },
          onError: (error: any, file: any) => {
            this.loading = false;
            this.message.error(this.translocoService.translate('itineraries.accommodation.messages.failedToUploadImage'));
            reject(error);
          }
        };

        this.uploadService.uploadFile(formData, uploadItem);

      } catch (error) {
        this.loading = false;
        this.message.error(this.translocoService.translate('itineraries.accommodation.messages.failedToDownloadImageFromUrl'));
        reject(error);
      }
    });
  }

  private isS3Url(url: string): boolean {
    // Check if the URL is already an S3 URL
    // You can customize this check based on your S3 bucket domain
    return url.includes('s3.amazonaws.com') ||
           url.includes('amazonaws.com') ||
           url.includes('your-s3-bucket-domain.com') ||
           url.startsWith('https://your-bucket-name.s3.');
  }

  onDownloadAttachment(attachment: any): void {
    if (!attachment || !attachment.url) {
      this.message.error(this.translocoService.translate('itineraries.accommodation.messages.attachmentUrlNotFound'));
      return;
    }

    try {
      this.fileService.downloadAttachment(attachment.url, attachment.name);
      this.message.info(this.translocoService.translate('itineraries.accommodation.messages.downloading', { name: attachment.name }));
    } catch (error) {
      this.message.error(this.translocoService.translate('itineraries.accommodation.messages.failedToDownloadAttachment'));
    }
  }

  formatter = currencyFormatter;
  parser = amountParser;
}
